import { render, staticRenderFns } from "./CountBadge.vue?vue&type=template&id=20b0fbd8&scoped=true&"
import script from "./CountBadge.vue?vue&type=script&lang=js&"
export * from "./CountBadge.vue?vue&type=script&lang=js&"
import style0 from "./CountBadge.vue?vue&type=style&index=0&id=20b0fbd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0fbd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
